import {
  Directive,
  HostListener,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[debounceClick]', // Selector for applying the directive
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  // Input properties for the directive to control its behavior
  @Input() debounceTime: number = 300;
  @Output() debounceClick = new EventEmitter<void>();

  private clickSubject = new Subject<void>();
  private destroy$ = new Subject<void>(); // Subject for unsubscription

  ngOnInit(): void {
    // Subscribe to the debounced click subject
    this.clickSubject.pipe(debounceTime(this.debounceTime), takeUntil(this.destroy$)).subscribe(() => {
      this.debounceClick.emit(); // Emit the debounced button click
    });
  }

  ngOnDestroy(): void {
    // Clean up the subscription when the directive is destroyed
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    // Emit the click event, but debounce rapid clicks
    this.clickSubject.next();
  }
}
